class LoginSignup extends HTMLElement {
  currentView = 'signup';

  constructor() {
    super();

    if (window.location.pathname === '/account/login') {
      this.currentView = 'login';
    }

    this.setupListeners();
    this.render();
  }

  toggleView() {
    this.currentView = this.currentView === 'login' ? 'signup' : 'login';
    this.render();
  }

  toggleBackgrounds() {
    if (this.currentView === 'signup') {
      this.querySelector('.signup__wrapper').classList.remove('bg-light');
      this.querySelector('.login__wrapper').classList.add('bg-light');
    } else {
      this.querySelector('.signup__wrapper').classList.add('bg-light');
      this.querySelector('.login__wrapper').classList.remove('bg-light');
    }
  }

  hideUnselectedView() {
    if (this.currentView === 'signup') {
      this.querySelector('.login__body').style.display = 'none';
      this.querySelector('.login__opener').style.display = 'block';
      this.querySelector('.signup__body').style.display = 'block';
      this.querySelector('.signup__opener').style.display = 'none';
    } else {
      this.querySelector('.login__body').style.display = 'block';
      this.querySelector('.login__opener').style.display = 'none';
      this.querySelector('.signup__body').style.display = 'none';
      this.querySelector('.signup__opener').style.display = 'block';
    }
  }

  setupListeners() {
    this.querySelectorAll('.login__opener button, .signup__opener button').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.toggleView();
      });
    });
  }

  render() {
    this.toggleBackgrounds();
    this.hideUnselectedView();
  }
}

if (!customElements.get('login-signup')) {
  customElements.define('login-signup', LoginSignup);
}
